// src/utils/persianUtils.ts

/**
 * Converts English digits (0-9) to Persian digits (۰-۹).
 * Handles numbers, strings, or null/undefined values.
 */
export const toPersianDigits = (value: number | string | undefined | null): string => {
    if (value === null || value === undefined) return '';

    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

    return value.toString().replace(/[0-9]/g, (w) => persianDigits[+w]);
};

/**
 * A formatted number in Persian digits and separators: «1,619.42» → «۱٬۶۱۹٫۴۲», «0.86%» → «۰٫۸۶%».
 * Only digits, «.» and «,» change, so a string that is already Persian stays the same.
 */
export const toPersianNumber = (value: number | string | undefined | null): string =>
    toPersianDigits(value).replace(/\./g, '٫').replace(/,/g, '٬');
